var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import classNames from 'classnames';
import Cell from './Cell';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { Checkbox } from '@mui/material';
export var ROW_ITEM_DRAG_TYPE = 'ROW_ITEM';
var beginDrag = function (monitor, props) {
    return __assign(__assign({}, monitor.getItem()), { type: ROW_ITEM_DRAG_TYPE, rowItem: props.item });
};
var collectDragProps = function (monitor) {
    return {
        isDragging: monitor.isDragging(),
    };
};
var Row = function (props) {
    var isHighlighted = props.isHighlighted, columns = props.columns, item = props.item, onRowClick = props.onRowClick, cellFactory = props.cellFactory, rowSelectionManager = props.rowSelectionManager;
    var _a = useDrag({
        item: {
            type: ROW_ITEM_DRAG_TYPE,
        },
        canDrag: item.canDrag,
        begin: function (monitor) { return beginDrag(monitor, props); },
        collect: collectDragProps,
    }), dragRef = _a[1], connectDragPreview = _a[2];
    useEffect(function () {
        connectDragPreview(getEmptyImage(), { captureDraggingState: true });
    }, []);
    if (!item) {
        return null;
    }
    return (React.createElement("tr", { ref: dragRef, onClick: onRowClick ? function () { return onRowClick(item); } : undefined, className: classNames({ highlighted: isHighlighted }) },
        rowSelectionManager.isEnabled && React.createElement("td", { className: "accDataTable__checkboxCell", onClick: rowSelectionManager.onParentClick },
            React.createElement(Checkbox, { checked: rowSelectionManager.isRowSelected(item), onChange: function () { return rowSelectionManager.onRowCheckboxChange(item); } })),
        columns.map(function (column, index) {
            return React.createElement(Cell, { key: column.name + index, cellFactory: cellFactory, column: column, item: item });
        })));
};
export default React.memo(Row);
//# sourceMappingURL=Row.js.map